import { forwardRef } from 'react';

import {
  Row as RACRow,
  type RowProps as RACRowProps,
} from 'react-aria-components/Table';

import { cx } from '../../utils/cx';

import styles from './table_view.module.css';

export type RowProps<T = object> = RACRowProps<T> & {
  className?: string;
};

/**
 * Row - A table row containing cells.
 */
export const Row = forwardRef<HTMLTableRowElement, RowProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <RACRow ref={ref} className={cx([styles.row, className])} {...props}>
        {children}
      </RACRow>
    );
  },
);
